const gcd = (a, b) => b === 0n ? a : gcd(b, a % b);
const reduce = (n, d) => { if (d <= 0n || n < 0n)
    throw Error('Use a non-negative share and a positive denominator.'); const g = gcd(n, d); return { n: n / g, d: d / g }; };
const plus = (a, b) => reduce(a.n * b.d + b.n * a.d, a.d * b.d);
function decimal(text) { if (!/^(?:0|[1-9]\d{0,8})(?:\.\d{1,9})?$/.test(text))
    throw Error('Use an explicit percentage or fraction, with at most nine decimal places.'); const [whole, part = ''] = text.split('.'); return reduce(BigInt(whole + part), 10n ** BigInt(part.length)); }
export function costShare(text) {
    const value = text.trim();
    let result;
    if (value.includes('/')) {
        const pieces = value.split('/');
        if (pieces.length !== 2)
            throw Error('Enter a complete fraction such as 10/11.');
        const a = decimal(pieces[0].trim()), b = decimal(pieces[1].trim());
        result = reduce(a.n * b.d, a.d * b.n);
    }
    else {
        const p = decimal(value.replace(/%$/, ''));
        result = reduce(p.n, p.d * 100n);
    }
    if (result.n > result.d)
        throw Error('A share cannot exceed 100%.');
    return result;
}
export function checkCostShares(shares) { const values = shares.map(costShare), sum = values.reduce(plus, { n: 0n, d: 1n }); if (sum.n !== sum.d)
    throw Error('Enter shares totalling exactly 100% (or a whole fraction).'); return values; }
/** Largest remainder. Ties follow the supplied, stable display order. */
export function allocateCostPennies(total, shares) {
    if (!Number.isSafeInteger(total) || total < 0)
        throw Error('Use a safe non-negative penny amount.');
    const values = checkCostShares(shares);
    const parts = values.map((v, i) => ({ i, floor: BigInt(total) * v.n / v.d, remainder: BigInt(total) * v.n % v.d, d: v.d }));
    const remainder = BigInt(total) - parts.reduce((s, p) => s + p.floor, 0n);
    const ranked = [...parts].sort((a, b) => { const delta = a.remainder * b.d - b.remainder * a.d; return delta === 0n ? a.i - b.i : delta > 0n ? -1 : 1; });
    for (let i = 0; i < Number(remainder); i++)
        ranked[i].floor++;
    return parts.map(p => Number(p.floor));
}
export const fixedScheduleSplitRules = [{ id: 'residential-only', name: 'Residential only', residential: '100%', commercial: '0%' }, { id: 'commercial-only', name: 'Commercial only', residential: '0%', commercial: '100%' }];
export function findScheduleSplitRule(id, custom) { const matches = [...fixedScheduleSplitRules, ...custom].filter(r => r.id === id); if (matches.length !== 1)
    throw Error('Choose a split between schedules for every cost.'); checkCostShares([matches[0].residential, matches[0].commercial]); return matches[0]; }
//# sourceMappingURL=schedule-cost-split.js.map